import PublicPlaylistView from './PublicPlaylistView';

export default function PlaylistRoute() {
    return <PublicPlaylistView />;
}
